import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import useGroup from '../../hooks/use_group';
import useMarker from '../../hooks/use_marker';
import useTranslation from '../../hooks/use_translation';
import { getGroupsByMarker } from '../../utils/helpers';
import Btn from '../framework/buttons/btn';
import ReadMoreLink from '../framework/read-more-link';
import Trans from '../translation/trans';
import MarkerThumb from './marker-thumb';

const ServiceGroupTabs = ({ include_markers }) => {
	const { items: groups } = useGroup({
		include_types: ['marker', 'marker_domain'],
	});
	let { items: markers } = useMarker({ include_markers });
	const { t } = useTranslation('component_service_group_tabs');

	if (!include_markers || !include_markers.length) return;

	markers = markers.map((marker) => {
		if (marker.marker_id === 1) marker.groups = null;
		return marker;
	});

	const groups_filtered = getGroupsByMarker({
		fallback_group: { title: t('t4') },
		groups: groups.filter((group) => group.type == 'marker_domain'),
		markers,
	});

	const getGroupImage = (group_id) => {
		let out = null;
		const match = groups.find(
			(item) => item.group_id == group_id && item?.fields?.files_icon_url_src,
		);
		if (match) out = match?.fields?.files_icon_url_src;
		return out;
	};

	return (
		<section className="" id="service-group-accordions">
			<div className="accordion accordion-flush" id="marker-groups">
				{groups_filtered.items.map((group, index1) => {
					const group_id = Number(group.group_id);
					const image = getGroupImage(group_id);
					const groupMarkersCount = markers.filter((marker) =>
						marker?.groups?.includes(group_id),
					).length;
					return (
						<div className="accordion-item" key={index1}>
							<h4 className="accordion-header" id={`marker-group-${group_id}`}>
								<button
									aria-controls={`marker-group-content-${group_id}`}
									aria-expanded="false"
									className="accordion-button d-flex sm bg-gray-100 collapsed"
									data-bs-target={`#marker-group-content-${group_id}`}
									data-bs-toggle="collapse"
									type="button"
								>
									{image && (
										<GatsbyImage
											alt={`${group.title} icon`}
											className="icon-md img-fluid me-2"
											image={getImage(image)}
										/>
									)}
									<span>
										{group.title}{' '}
										{groupMarkersCount > 0 && <>({groupMarkersCount})</>}
									</span>
								</button>
							</h4>

							<div
								aria-labelledby={`marker-group-${group_id}`}
								className={`accordion-collapse collapse `}
								id={`marker-group-content-${group_id}`}
							>
								<div className="accordion-body bg-gray-100 accordion-body-sm px-0 pt-0">
									<div className="row px-2 justify-content-between">
										<div className="col ps-1">
											{group.excerpt && (
												<p>
													<Trans defaults={group.excerpt} t={t} />
												</p>
											)}
											<div className="mt-3">
												{markers
													.filter((marker) => {
														if (marker?.groups?.includes(group_id)) {
															return true;
														} else if (!group_id && !marker?.groups?.length) {
															return true;
														}

														return false;
													})
													.map((marker, index2) => {
														const marker_group_id = groups.find(
															(item) =>
																marker?.groups?.includes(item.group_id) &&
																item.type == 'marker',
														)?.group_id;

														return (
															<span key={index2}>
																<div
																	aria-labelledby="offcanvasMarkerLabel"
																	className="offcanvas offcanvas-end"
																	data-bs-scroll="true"
																	id={`offcanvas-marker-${marker.marker_variant.marker_variant_id}`}
																>
																	<div className="offcanvas-header">
																		<div className="d-flex flex-row">
																			<span className="me-1">
																				<MarkerThumb
																					groups={[marker_group_id]}
																					markers={[marker.marker_id]}
																					size="sm"
																				/>
																			</span>

																			<h5 id="offcanvasMarkerLabel d-inline">
																				{marker.marker_variant.title}
																			</h5>
																		</div>
																		<button
																			aria-label="Close"
																			className="btn-close text-reset"
																			data-bs-dismiss="offcanvas"
																			type="button"
																		></button>
																	</div>
																	<div className="offcanvas-body lg">
																		<Trans
																			defaults={marker.marker_variant.excerpt}
																			t={t}
																		/>
																		<ReadMoreLink
																			groups={[marker_group_id]}
																			label={t('t3')}
																			marker_id={marker.marker_id}
																			page={
																				marker.type == 'allergen'
																					? 'allergener'
																					: 'markorer'
																			}
																		/>
																	</div>
																</div>
																<Btn
																	aria-controls={`offcanvas-marker-${marker.marker_variant.marker_variant_id}`}
																	className="ms-1 mb-1 bg-white border-0"
																	color="light"
																	component="button"
																	data-bs-toggle="offcanvas"
																	href={`#offcanvas-marker-${marker.marker_variant.marker_variant_id}`}
																	leftSection={
																		<MarkerThumb
																			groups={[marker_group_id]}
																			markers={[marker.marker_id]}
																			size="xs"
																		/>
																	}
																	removePill
																	size="xs"
																	type="button"
																	variant="thumb_btn"
																	withShadow
																	withThumb
																>
																	{marker.marker_variant.title}
																</Btn>
															</span>
														);
													})}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</section>
	);
};

ServiceGroupTabs.propTypes = {
	include_markers: PropTypes.array.isRequired,
};

export default ServiceGroupTabs;
